module.exports = __webpack_public_path__ + "static/img/share-guide.41a2e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ordering/share-guide.png
// module id = J23T
// module chunks = 4